import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps } from 'common/components/antd/Button/Button';
import { IconButton } from 'common/components/IconButton/IconButton';
import { SIcon } from './ColumnsSettingsButton.style';

type ColumnSettingsButtonProps = Omit<ButtonProps, 'icon'>;

export const ColumnSettingsButton = (props: ColumnSettingsButtonProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <IconButton icon={<SIcon />} {...props}>
      {t('ui.button.columns')}
    </IconButton>
  );
};
